<template>
  <div style="xborder: 1px solid red;">
    <v-layout row>
      <v-flex sm8 class="mr-2">
<v-autocomplete
      :items="Leistungen"
      :search-input.sync="search"
      :loading="isLoading"
      item-text="text"
      item-value="id"
      v-model.lazy="Leistung"
      label="Handwerksleistung"
      hide-details
      prepend-inner-icon="search"
      no-data-text="Stichwort eintippen und dann auswählen"
      cache-items
      :browser-autocomplete="HackOne"
      required
      validate-on-blur
      v-validate="'required'"
      :error-messages="errors.collect('Leistung')"
      data-vv-name="Leistung"
      :class="{ invalid: errors.has('Leistung') }"
      @keyup.enter="validateForm()"
    >
      <template slot="item" slot-scope="data">
          <v-list-tile-avatar>
            <img :src="data.item.logo" :alt="data.item.name" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title
              v-html="data.item.text"
              :class="{ leistungfett: data.item.defaultleistung }"
            >
            </v-list-tile-title>
            <v-list-tile-sub-title v-html="data.item.gewerk">
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </template>
    </v-autocomplete>
      </v-flex>
      <v-flex>
         <v-autocomplete
            v-bind:items="this.$store.getters.fetchBetriebe.staedte"
            item-value="id"
            v-model="Stadt"
            required
            hide-details
            label="Stadt"
            clearable
            :loading="isLoading"
            :browser-autocomplete="autoCompleteHackTwo"
            prepend-inner-icon="location_searching"
            no-data-text="Stadt nicht gefunden.."
            xv-validate="'required'"
            v-validate="{ required: !plzsuche }"
            xvalidate-on-blur
            data-vv-name="Stadt"
            @change="Postleitzahl = ''"
            :error-messages="errors.collect('Stadt')"
            :class="{ invalid: errors.has('Stadt') }"
            @keyup.enter="validateForm()"
          ></v-autocomplete> 
      </v-flex>
      <v-flex>
        <v-btn 
          @click="validateForm()"
          flat 
          class="accent pl-4"           
          type="submit"
          :loading="busy"
          >Suchen<v-icon right>search</v-icon>
        </v-btn> 
      </v-flex>
    </v-layout>
    
   
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const dict = {
  custom: {
    Stadt: {
      required: 'Bitte einen Standort auswählen'
    },
    Leistung: {
      required: 'Bitte eine Leistung auswählen'
    }
  }
}
export default {
  metaInfo () {
    return { title: this.SuchbegriffGross + ' in ' + this.StadtNameGross }
  },

  components: {},
  data: () => ({
    Leistung: [],
    showinfos: true,
    select: [],
    isLoading: false,
    search: null,
    HackOne: 'das2das',
    autoCompleteHackTwo: 'fail',
    plzsuche: false,
    Stadt: [],
    busy: false
  }),
  computed: {
    ...mapGetters({
      fetchBetriebe: 'fetchBetriebe'
    }),
    StadtVuex: function () {
      // return this.$store.state.suche.stadt
      return this.$store.getters.fetchStandort.name.name
    },
    LeistungVuex: function () {
      return this.$store.getters.fetchSuchbegriff
    },
    Leistungen: function () {
      if (this.$store.getters.fetchBetriebe.leistungen) {
        return this.$store.getters.fetchBetriebe.leistungen.filter((leistung) => {
          return leistung.defaultleistung === 1
        })
      }
    },
    PLZ: function () {
      return this.$store.state.suche.plz
    }
  },
  mounted: function () {
    this.setKeys()
  },

  methods: {
    setKeys () {
      this.Stadt = this.StadtVuex
      this.Leistung = this.LeistungVuex.id
    },
    validateForm () {
      this.$validator.localize('de', dict)
      this.$validator.validateAll().then(result => {
        if (result) {
          // eslint-disable-next-line
          this.vuexBetriebe()

          return
        }
      })
    },
    async vuexBetriebe () {
      if (this.Stadt || this.Postleitzahl) {
        this.busy = true
        var payload = {
          leistung: this.Leistung,
          standort: this.Stadt
          // postleitzahl: this.Postleitzahl,
          // plzsuche: this.plzsuche,
          // range: this.range
        // standort: this.$store.state.landing.HeimatStadt
        // suchbegriff: suchbegriff.text
        }
        console.log(payload)
        await this.$store.dispatch('fetchBetriebe', payload).then(() => {
          if (!this.$store.getters.fetchBetriebe.error) {
            // this.$router.push({
            //   name: 'handwerker'
            // })
          }
        })
        this.busy = false
        this.$emit('busy', false)
      } else {
        this.plzsuche = false
        console.log('bitte location wählen')
      }
    }
  }
}
</script>
<style>
</style>